import * as z from "zod";

export const signupSchema = z
  .object({
    username: z
      .string()
      .min(3, "Username must be 3-30 characters")
      .max(30, "Username must be 3-30 characters")
      .refine(
        (value) =>
          !value.includes("@") || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
        {
          message: "Username cannot be in email format",
        }
      ),
    email: z.string().email("Invalid email address"),
    password: z
      .string()
      .min(12, "Password must be at least 12 characters")
      .regex(/[A-Z]/, "Must include an uppercase letter")
      .regex(/[a-z]/, "Must include a lowercase letter")
      .regex(/[0-9]/, "Must include a number")
      .regex(/[^A-Za-z0-9]/, "Must include a special character"),
    confirmPassword: z
      .string()
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  })
  .refine((data) => data.username !== data.email, {
    path: ["email"],
    message: "Username and email must be different",
  })
  .refine(
    (d) => {
      const lowerPw = d.password.toLowerCase();
      const localEmail = d.email.split("@")[0].toLowerCase();
      return (
        !lowerPw.includes(d.username.toLowerCase()) &&
        !lowerPw.includes(localEmail)
      );
    },
    {
      path: ["password"],
      message: "Must not contain your username or email",
    }
  );

export type SignupFormData = z.infer<typeof signupSchema>;
